import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';
import { Chat } from '../../models/chat';

@inheritSerialization(LoadableState)
export class ChatsState extends LoadableState {
  public static readonly key = 'ChatsState';

  @autoserializeAs(Chat, 'chats')
  public chats: Chat[] = [];

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;

}
